module.exports = __webpack_public_path__ + "static/media/S (104).16936c77.jpg";